import React from 'react';

import PropTypes from 'prop-types';

import { stylePropType, StylableComponent } from '@adsk/alloy-react-helpers';
import ProgressRing from '@adsk/alloy-react-progress-ring';
import theme from '@adsk/alloy-react-theme';

type ActivityLoaderProps = Omit<StylableComponent<HTMLDivElement>, 'title'>;

/**
 * ActivityLoader component. Can be used as the last activity in a list to show loading indication.
 */
const ActivityLoader = React.forwardRef<HTMLDivElement, ActivityLoaderProps>(
  ({ className, style, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={className}
        css={[
          {
            display: 'flex',
            backgroundColor: theme.colors.white,
            width: '100%',
          },
          style,
        ]}
        {...props}
      >
        <div
          css={[
            {
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              paddingLeft: 25,
            },
          ]}
        >
          {
            <div
              css={[
                {
                  height: 23,
                  width: 1,
                  backgroundColor: theme.colors.charcoal200,
                  marginRight: 1,
                },
              ]}
            />
          }
        </div>
        <div
          css={[
            {
              display: 'flex',
              flexDirection: 'column',
              padding: 16,
              overflow: 'auto',
              flex: 1,
            },
          ]}
        >
          <ProgressRing size={ProgressRing.SIZES.XSMALL} />
        </div>
      </div>
    );
  }
);

ActivityLoader.displayName = 'ActivityLoader';

ActivityLoader.propTypes = {
  /** Styles applied to the root element */
  style: stylePropType,
  /** Class applied to the root element */
  className: PropTypes.string,
};

export default ActivityLoader;
